var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4207 0.23591C11.8533 -0.101254 12.4916 -0.0769291 12.8948 0.30836L13.2842 0.680374C13.4908 0.877724 13.6069 1.14531 13.6069 1.4244C13.6069 1.70349 13.4908 1.97109 13.2842 2.16843L8.94666 6.31197L13.6774 10.8316C14.1075 11.2426 14.1075 11.9087 13.6774 12.3197L13.288 12.6917C12.8578 13.1027 12.1606 13.1027 11.7305 12.6917L6.99972 8.17204L2.26953 12.6917C2.06297 12.889 1.78287 13 1.49076 13C1.19863 13 0.918547 12.8891 0.711981 12.6917L0.322594 12.3197C-0.107542 11.9087 -0.107521 11.2426 0.322594 10.8316L5.05279 6.31197L0.715746 2.16843C0.285595 1.75747 0.285595 1.09133 0.715746 0.680374L1.10513 0.30836L1.1885 0.23591C1.62113 -0.101252 2.2594 -0.076931 2.66268 0.30836L6.99972 4.4519L11.3373 0.30836L11.4207 0.23591Z",
    fill: "#AD2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCrossIcon);
export default __webpack_public_path__ + "static/media/redCrossIcon.748972cecef94ede25a7edac58c19fd0.svg";
export { ForwardRef as ReactComponent };